/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect, useState } from 'react';

import { cssMap, jsx } from '@atlaskit/css';

// Colors synchronized with shape transitions
const morphColors = [
	'#FCA700', // Orange (Circle)
	'#AF59E1', // Purple (Square)
	'#6A9A23', // Green (Triangle)
	'#1868DB', // Blue (Hexagon)
	'#FCA700', // Back to Orange (Circle)
];

// Shape indices for cycling through
const shapes = [0, 1, 2, 3, 0];

const styles = cssMap({
	container: {
		width: '24px',
		height: '24px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'visible',
	},
	svg: {
		overflow: 'visible',
	},
	pathTransition: {
		transition: 'fill 0.6s ease, d 0.6s ease',
	},
});

type MorphingLoaderProps = {
	testId?: string;
};

export const MorphingLoader = ({ testId }: MorphingLoaderProps) => {
	const [currentShape, setCurrentShape] = useState(0);

	// Cycle through shapes every 600ms
	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentShape((prev) => (prev + 1) % shapes.length);
		}, 600);

		return () => clearInterval(interval);
	}, []);

	const getShapePath = (shapeIndex: number): string => {
		switch (shapeIndex) {
			case 0:
				// Circle
				return 'M 50, 50 m -25, 0 a 25,25 0 1,0 50,0 a 25,25 0 1,0 -50,0';
			case 1:
				// Square
				return 'M 25 25 L 75 25 L 75 75 L 25 75 Z';
			case 2:
				// Triangle
				return 'M 50 20 L 80 70 L 20 70 Z';
			case 3:
				// Hexagon (regular flat-top)
				return 'M 50 25 L 75 37.5 L 75 62.5 L 50 75 L 25 62.5 L 25 37.5 Z';
			default:
				return 'M 50, 50 m -25, 0 a 25,25 0 1,0 50,0 a 25,25 0 1,0 -50,0';
		}
	};

	return (
		<div css={styles.container} data-testid={testId}>
			<svg width="30" height="30" viewBox="0 0 100 100" css={styles.svg}>
				<path
					d={getShapePath(currentShape)}
					fill={morphColors[currentShape]}
					stroke="none"
					css={styles.pathTransition}
				/>
			</svg>
		</div>
	);
};
